import { ApiService } from './';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class AssociationTypeService {

    constructor(private apiService: ApiService) { }

    list(): Observable<any> {
        return this.apiService.get('gandadmin/assoc_types')
    }
}
